// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"62cfb1cd","732":"56228813","977":"210311ad"}[chunkId] + ".chunk.js";
};